import { FileType } from '../features/data-set/data-set';

export function formatDate(date: string) {
  const dateParts = date.split('.');
  if (dateParts[1]) {
    dateParts[1] = dateParts[1].slice(0, 2);
    return dateParts.join('.');
  }
  return date;
}

export function mapFileType(fileType: FileType): string {
  switch (fileType) {
    case FileType.Csv:
      return '.csv';
    case FileType.Dicom:
      return '.dicom';
    case FileType.Vcf:
      return '.vcf';
    case FileType.Pdf:
      return '.pdf';
    case FileType.Xls:
      return '.xls';
    default:
      return '.bam';
  }
}
